export default __webpack_public_path__ + "static/media/beauty_2020_OV_seemore_EH-NA98-K_3_201127.a586e746.jpg";